import React, { useState,useEffect,useMemo, useRef } from 'react';
import { aNumero, formatearConPuntos } from '../../services/numeros';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase'; 
import { ReactComponent as EventosIcon } from '../../assets/icons/EventosIcon.svg';
import { ReactComponent as StaffIcon } from '../../assets/icons/StaffIcon.svg';
import { ReactComponent as MenuIcon } from '../../assets/icons/MenuIcon.svg';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import CalendarModal from './CalendarModal'
import { getAuth } from 'firebase/auth';
import { useNavigate, useParams } from 'react-router-dom';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption, Combobox  } from '@headlessui/react';
const EventosForm = () => {
const formatNumberWithDots = formatearConPuntos;
const normalizePrice = aNumero;
const { id } = useParams();
const isEditing = !!id;
const [isCalendarModalVisible, setIsCalendarModalVisible] = useState(false);
const [isLoading, setIsLoading] = useState(false);
const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saved'
const [progress, setProgress] = useState(0);
const navigate = useNavigate();
const [formData, setFormData] = useState({
fechas: [],
hora: '',
imagen: null,
titulo: '',
descripcion: '',
coleccion: [],
menu: '',
precio: '',
staff: [
{ nombre: '', rol: 'Chef' },
{ nombre: '', rol: 'Asistente de cocina' },
{ nombre: '', rol: 'Bachero' },
{ nombre: '', rol: 'Mozo' },
{ nombre: '', rol: 'Mozo' },
],
invitados: Array(14).fill(null),
});
const [vinos, setVinos] = useState([]);
const [contactos, setContactos] = useState([]);
const [selectedVino, setSelectedVino] = useState('');
const [vinoQuery, setVinoQuery] = useState('');
const [openClientListbox, setOpenClientListbox] = useState(null);
const [searchTerm, setSearchTerm] = useState('');
const dropdownRef = useRef(null);
const searchInputRef = useRef(null);
const filterButtonsRef = useRef([]);
const [contactTypeFilter, setContactTypeFilter] = useState('');
const [clientes, setClientes] = useState([]);
const [proveedores, setProveedores] = useState([]);
const [otros, setOtros] = useState([]);
const [usuarios, setUsuarios] = useState([]);
const [hoveredCircleIndex, setHoveredCircleIndex] = useState(null);
const [existingImageUrl, setExistingImageUrl] = useState('');
const filteredContactsByType = useMemo(() => {
let contactsToFilter = [];
switch (contactTypeFilter) {
case 'clientes':
contactsToFilter = clientes;
break;
case 'proveedores':
contactsToFilter = proveedores;
break;
case 'otros':
contactsToFilter = otros;
break;
case 'usuarios':
contactsToFilter = usuarios;
break;
case 'todos':
default:
contactsToFilter = contactos;
break;
}
const selectedContactIds = formData.invitados.filter((invitado) => invitado).map((invitado) => invitado.id);
const filtered = contactsToFilter.filter((contacto) => {
const isSelected = selectedContactIds.includes(contacto.id);
if (isSelected) return false;
const nombreCompleto = contacto.nombre && contacto.apellido 
? `${contacto.nombre} ${contacto.apellido}` 
: contacto.nombre 
? contacto.nombre 
: contacto.razonSocial 
? contacto.razonSocial 
: '';
return nombreCompleto.toLowerCase().includes(searchTerm.toLowerCase());
});
filtered.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
return filtered;
}, [contactTypeFilter, searchTerm, clientes, proveedores, otros, usuarios, contactos, formData.invitados]);
useEffect(() => {
const fetchAllData = async () => {
setIsLoading(true);
try {
const [vinosSnapshot, clientesSnapshot, proveedoresSnapshot, otrosSnapshot, usuariosSnapshot] = await Promise.all([
getDocs(query(collection(db, 'stock'), where('cantidadUnidades', '>', 0))),
getDocs(query(collection(db, 'clientes'))),
getDocs(query(collection(db, 'proveedores'))),
getDocs(query(collection(db, 'otros'))),
getDocs(query(collection(db, 'usuarios')))
]);
console.log('--- Verificación de Contactos de Firestore ---');
console.log(`Clientes encontrados: ${clientesSnapshot.docs.length}`);
console.log(`Proveedores encontrados: ${proveedoresSnapshot.docs.length}`);
console.log(`Otros encontrados: ${otrosSnapshot.docs.length}`);
console.log(`Usuarios encontrados: ${usuariosSnapshot.docs.length}`);
console.log('-------------------------------------------');
const vinosList = vinosSnapshot.docs
.map(doc => ({ id: doc.id, ...doc.data() }))
.filter(vino => vino.vino_id && !vino.id.startsWith('DEMO-')); // demo de fincalosastros
vinosList.sort((a, b) => a.id.localeCompare(b.id, 'es', { sensitivity: 'base' }));
setVinos(vinosList);
// Cuentas de staff usadas para probar el sitio público como si fueran
// clientes (Martín Gallo, Tomás Sitta) — ya aparecen abajo como 'usuarios',
// no deben duplicarse acá como 'clientes'. Sacar cuando ya no hagan falta.
const UIDS_CUENTAS_DE_PRUEBA = ['31464078', '42876938', '34853820', '36398917'];
const clientesList = clientesSnapshot.docs
.filter(doc => !UIDS_CUENTAS_DE_PRUEBA.includes(doc.id))
.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'clientes' }));
const proveedoresList = proveedoresSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'proveedores' }));
const otrosList = otrosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'otros' }));
const usuariosList = usuariosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data(), tipo: 'usuarios' }));
setClientes(clientesList);
setProveedores(proveedoresList);
setOtros(otrosList);
setUsuarios(usuariosList);
const allContacts = [...clientesList, ...proveedoresList, ...otrosList, ...usuariosList];
allContacts.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
setContactos(allContacts);
if (isEditing && id) {
const docRef = doc(db, "eventos", id);
const docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const eventData = docSnap.data();
const vinoIdsFromNames = eventData.coleccion
.map(nombreVino => {
const vinoEncontrado = vinosList.find(v => v.id === nombreVino);
return vinoEncontrado ? vinoEncontrado.vino_id : null;
})
.filter(vinoId => vinoId);
setFormData({
fechas: eventData.fechas.map(f => {
if (f.seconds) {
return new Date(f.seconds * 1000);
} else {
return new Date(f);
}
}),
hora: eventData.hora || '',
imagen: null,
titulo: eventData.titulo || '',
descripcion: eventData.descripcion || '',
coleccion: vinoIdsFromNames,
menu: eventData.menu || '',
precio: eventData.precio ? formatNumberWithDots(eventData.precio.toString()) : '',
staff: eventData.staff || [
{ nombre: '', rol: 'Chef' },
{ nombre: '', rol: 'Asistente de cocina' },
{ nombre: '', rol: 'Bachero' },
{ nombre: '', rol: 'Mozo' },
{ nombre: '', rol: 'Mozo' },
],
invitados: eventData.invitados || Array(14).fill(null),
});
setExistingImageUrl(eventData.imagen || '');
} else {
console.log("No se encontró el documento.");
navigate('/eventos');
}
}
} catch (error) {
console.error("Error al cargar datos:", error);
} finally {
setIsLoading(false);
}
};
fetchAllData();
}, [id, isEditing, navigate]);
const handleMouseEnter = (index) => {
setHoveredCircleIndex(index);
};
const handleStaffChange = (e, index) => {
const newStaff = [...formData.staff];
newStaff[index].nombre = e.target.value;
setFormData({ ...formData, staff: newStaff });
};
const handleMouseLeave = () => {
setHoveredCircleIndex(null);
};
const handleAddVino = (vinoId) => {
if (vinoId && !formData.coleccion.includes(vinoId)) {
setFormData({
...formData,
coleccion: [...formData.coleccion, vinoId],
});
setSelectedVino('');
}
};
const handleSelectClient = (cliente, index) => {
const newInvitados = [...formData.invitados];
newInvitados[index] = cliente;
setFormData({ ...formData, invitados: newInvitados });
setOpenClientListbox(null);
};
const handleRemoveClient = (index) => {
const newInvitados = [...formData.invitados];
newInvitados[index] = null;
setFormData({ ...formData, invitados: newInvitados });
};
const filteredContacts = useMemo(() => {
const selectedContactIds = formData.invitados.filter((invitado) => invitado).map((invitado) => invitado.id);
const filtered = contactos.filter((contacto) => {
const isSelected = selectedContactIds.includes(contacto.id);
if (isSelected) {
return false;
}
const nombreCompleto = contacto.nombre && contacto.apellido 
? `${contacto.nombre} ${contacto.apellido}` 
: contacto.nombre 
? contacto.nombre 
: contacto.razonSocial 
? contacto.razonSocial 
: '';
return nombreCompleto.toLowerCase().includes(searchTerm.toLowerCase());
});
filtered.sort((a, b) => {
const nameA = a.nombre && a.apellido ? `${a.nombre} ${a.apellido}` : a.nombre ? a.nombre : a.razonSocial || '';
const nameB = b.nombre && b.apellido ? `${b.nombre} ${b.apellido}` : b.nombre ? b.nombre : b.razonSocial || '';
return nameA.localeCompare(nameB);
});
return filtered;
}, [contactos, searchTerm, formData.invitados]);
const fileInputRef = useRef(null);
const handleChange = (e) => {
const { name, value } = e.target;
if (name === "precio") {
setFormData({ ...formData, [name]: formatNumberWithDots(value) });
} else {
setFormData({ ...formData, [name]: value });
}
};
const handleImageChange = (e) => {
setFormData({ ...formData, imagen: e.target.files[0] });
};
const handleArrayChange = (e, index, arrayName) => {
const newArray = [...formData[arrayName]];
newArray[index] = e.target.value;
setFormData({ ...formData, [arrayName]: newArray });
};
const handleAddArrayItem = (arrayName) => {
if (arrayName === 'invitados') return;
if (arrayName === 'staff') {
setFormData({ 
...formData, 
staff: [...formData.staff, { nombre: '', rol: 'Otro' }] 
});
} else {
setFormData({ ...formData, [arrayName]: [...formData[arrayName], ''] });
}
};
const handleRemoveArrayItem = (index, arrayName) => {
if (arrayName === 'invitados') return;
const newArray = [...formData[arrayName]];
newArray.splice(index, 1);
setFormData({ ...formData, [arrayName]: newArray });
};
const handleOpenCalendarModal = (index = null) => {
setIsCalendarModalVisible(true);
};
const handleCloseCalendarModal = () => {
setIsCalendarModalVisible(false);
};
const handleDatesSelected = ({ selectedDates, selectedTime }) => {
selectedDates.sort((a, b) => a - b);
setFormData({
...formData,
fechas: selectedDates,
hora: selectedTime,
});
handleCloseCalendarModal();
};
const handleButtonClick = () => {
fileInputRef.current.click();
};
const availableVinos = vinos.filter(
(vino) => !formData.coleccion.includes(vino.vino_id)
);
const filteredVinos =
vinoQuery === ''
? availableVinos
: availableVinos.filter((vino) => {
const vinoNombreCompleto = `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}`;
return vinoNombreCompleto.toLowerCase().includes(vinoQuery.toLowerCase());
});
const handleSubmit = async (e) => {
e.preventDefault();
setIsLoading(true);
setSaveState('idle');
setProgress(0);
const invitadosSeleccionados = formData.invitados.filter((i) => i !== null);
const user = getAuth().currentUser;
if (!user) {
console.error("Usuario no autenticado.");
setIsLoading(false);
return;
}
let fakeProgress = 0;
const interval = setInterval(() => {
fakeProgress += 10;
setProgress(fakeProgress);
if (fakeProgress >= 90) clearInterval(interval);
}, 200);
try {
const idToken = await user.getIdToken();
const formDataToSend = new FormData();
formDataToSend.append("titulo", formData.titulo);
formDataToSend.append("descripcion", formData.descripcion);
formDataToSend.append("menu", formData.menu);
formDataToSend.append("precio", normalizePrice(formData.precio));
formDataToSend.append("hora", formData.hora);
formDataToSend.append("fechas", JSON.stringify(formData.fechas));
formDataToSend.append("coleccion", JSON.stringify(formData.coleccion));
formDataToSend.append("staff", JSON.stringify(formData.staff));
formDataToSend.append("invitados", JSON.stringify(invitadosSeleccionados));
if (formData.imagen) {
formDataToSend.append("imagen", formData.imagen);
} else if (isEditing && existingImageUrl) {
formDataToSend.append("imagenUrlExistente", existingImageUrl);
}
const endpoint = isEditing ? `https://backend-288175208699.europe-west1.run.app/actualizar-evento/${id}` : "https://backend-288175208699.europe-west1.run.app/nuevo-evento";
const method = isEditing ? "PUT" : "POST";
const res = await fetch(endpoint, {
method: method,
headers: {
Authorization: `Bearer ${idToken}`,
},
body: formDataToSend,
});
const data = await res.json();
if (!res.ok) throw new Error(data.error || "Error en la operación");
clearInterval(interval);
setProgress(100);
setSaveState('saved');
setTimeout(() => {
navigate('/eventos');
}, 800);
} catch (error) {
alert(error.message);
setIsLoading(false);
setProgress(0);
}
};
useEffect(() => {
const handleOutsideClick = (event) => {
if (openClientListbox !== null) {
const dropdownElement = dropdownRef.current;
const searchInputElement = searchInputRef.current;
const isClickInsideFilterButtons = filterButtonsRef.current.some(
(button) => button && button.contains(event.target)
);
if (
dropdownElement &&
!dropdownElement.contains(event.target) &&
!(searchInputElement && searchInputElement.contains(event.target)) &&
!isClickInsideFilterButtons
) {
setOpenClientListbox(null);
}
}
};
document.addEventListener('mousedown', handleOutsideClick);
return () => {
document.removeEventListener('mousedown', handleOutsideClick);
};
}, [openClientListbox]);
return (
<div style={{ padding: '0 16px',overflow:'hidden',height:'100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Eventos</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<EventosIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle"> {isEditing ? "Actualizar datos del evento" : "Crear un nuevo evento"}</h1>
</div>
<hr className="divider" />
<form className="form" onSubmit={handleSubmit} style={{ maxHeight: '75vh' }}>
<div className="eventos-form-grid-container">
<div className="eventos-form-main-column">
<div className="eventos-form-grid-row-top" >
<div className="eventos-form-input" onClick={() => handleOpenCalendarModal()}  style={{ borderRadius: '7px', width: '100%' }}>
<span>Seleccionar fecha y hora</span>
</div>
<input type="file" id="imagen" name="imagen" accept="image/*" onChange={handleImageChange} ref={fileInputRef} style={{ display: 'none' }} />
<div onClick={handleButtonClick} className="eventos-form-input-group number" style={{ borderRadius: '7px', cursor: 'pointer', padding: ' 2px 5px 2px 10px', width: '100%' }}>
<span style={{ cursor: 'pointer' }}>{formData.imagen ? `${formData.imagen.name}` : 'Imagen del banner (1920x470)'}</span>
<div className="add-fecha">+</div>
</div>
</div>
{formData.fechas.length > 0 && formData.hora && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '5px', padding: '0 0 0', margin: '0' }}>
{formData.fechas.map((date, index) => (
<div
key={index}
className="eventos-form-input-group number"
style={{ minWidth: '80px', borderRadius: '50px', maxWidth: 'fit-content', padding: ' 2px 10px ' }}
>
<span onClick={() => handleOpenCalendarModal()} style={{ cursor: 'pointer' }}>
{(() => {
const formattedDate = date.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
const capitalizedDay = formattedDate.substring(0, 1).toUpperCase() + formattedDate.substring(1);
return capitalizedDay;
})()}
</span>
<div className="add-fecha" style={{ right: '0', background: 'none', fontSize: '17px' }} onClick={() => handleRemoveArrayItem(index, 'fechas')}>
&times;
</div>
</div>
))}
{formData.fechas.length > 0 && formData.hora && (
<div
className="eventos-form-input-group number"
style={{ borderRadius: '50px', maxWidth: 'fit-content', padding: ' 2px 10px ' }}
>
<span onClick={() => handleOpenCalendarModal()} style={{ cursor: 'pointer' }}>
{formData.hora}
</span>
</div>
)}
</div>
)}
<div className="eventos-form-input-group">
<input className="eventos-form-input eventos-form-large-input" type="text" id="titulo" name="titulo" value={formData.titulo} onChange={handleChange} placeholder="Título del evento" required />
</div>
<div className="eventos-form-input-group" style={{display:'flex',gap:'0',flexDirection:'column',borderRadius:'7px',backgroundColor:'#f6f7fa', }}>
<textarea 
className="eventos-form-input eventos-form-large-input" 
id="descripcion" 
name="descripcion" 
value={formData.descripcion} 
onChange={handleChange} 
rows={2}
maxLength={140} 
placeholder="Descripción del evento" 
/>
<div style={{
textAlign: 'right',
fontSize: '12px',
color: '#888',
margin: '5px 7px'
}}>
{formData.descripcion.length} / 140
</div>
</div>
<div className="eventos-form-grid-row-bottom" style={{ height: '300px' }} >
<div className="eventos-form-sub-column" >
<div className="eventos-form-input-group">
<div className="input-group">
<Combobox
value={selectedVino}
onChange={(value) => {
handleAddVino(value);
setVinoQuery('');
}}
>
{({ open }) => (
<>
<div style={{ position: 'relative', width: '100%' }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? 'open' : ''} ${selectedVino ? 'selected' : 'placeholder'}`}
style={{ width: '90.25%', borderRadius:'5px' }}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => setVinoQuery(event.target.value)}
displayValue={(vinoId) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
return vino ? `${vino.bodega} ${vino.cepa} ${vino.linea} ${vino.vino_id}` : '';
}}
placeholder="Selecciona un vino"
style={{
flexGrow: 1,
padding: '0',
border: 'none',
outline: 'none',
backgroundColor: 'transparent',
}}
/><span className="custom-arrow-container" style={{marginRight:'5px'}}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options">
{filteredVinos.length === 0 && vinoQuery !== '' ? (
<div className="custom-listbox-option">No se encontraron vinos.</div>
) : (
filteredVinos.map((vino) => (
<Combobox.Option
key={vino.vino_id}
value={vino.vino_id}
className={({ active }) => `custom-listbox-option ${active ? 'active' : ''}`}
>
{`${vino.vino_id}`}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
</>
)}
</Combobox>
</div>
{formData.coleccion.length > 0 && (
<div style={{ display: 'flex', flexDirection: 'row', gap: '5px', flexWrap: 'wrap', marginTop: '10px' }}>
{formData.coleccion.map((vinoId, index) => {
const vino = vinos.find((v) => v.vino_id === vinoId);
if (!vino) return null;
return (
<div key={index} className="eventos-form-input-group number" style={{ minWidth: '80px', borderRadius: '50px', maxWidth: '100%', padding: '5px 10px ' }}>
<span style={{ cursor: 'default', maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'middle' }}>{vino.id}</span>
<div className="add-fecha" style={{ right: '5px', background: 'none', fontSize: '17px' }} onClick={() => handleRemoveArrayItem(index, 'coleccion')}>
&times;
</div>
</div>
);
})}
</div>)}
</div>
<div className="eventos-form-label-container" style={{ marginBottom: '5px' }}>
<MenuIcon className="eventos-form-icon" />
<label className="eventos-form-label">Menú</label>
</div>
<div className="eventos-form-input-group">
<textarea className="eventos-form-input textarea" id="menu" name="menu" value={formData.menu} onChange={handleChange} rows="9" placeholder="Menú del evento" />
</div>
<div className="eventos-form-input-group number">
<input
className="eventos-form-input"
style={{ width: 'fit-content' }}
type="text"
id="precio"
name="precio"
value={formData.precio}
onChange={handleChange}
placeholder="Valor del evento"
/>
<span className="unit">$</span>
</div>
</div>
<div className="eventos-form-sub-column">
<div className="eventos-form-label-container">
<StaffIcon className="eventos-form-icon" />
<label className="eventos-form-label">Staff</label>
</div>
<div className="eventos-form-input-group eventos-form-array">
{formData.staff.map((item, index) => {
return (
<div key={index} className="eventos-form-array-item" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
<input 
className="eventos-form-input" 
type="text" 
value={item.nombre}
onChange={(e) => handleStaffChange(e, index)}
placeholder={`Nombre del ${item.rol.toLowerCase()}`} 
style={{ flex: 1 }}
/>
{index >= 5 && (
<div 
className="add-fecha" 
style={{ right: '5px', background: 'none', fontSize: '17px', cursor: 'pointer', position:'relative' }} 
onClick={() => handleRemoveArrayItem(index, 'staff')}>
&times;
</div>
)}
</div>
);
})}
<div type="button" onClick={() => handleAddArrayItem('staff')} className="add-btn-container">
<span className="add-icon">+</span>
<span className="add-txt">Agregar otro integrante</span>
</div>
</div>
</div>
</div>
</div>
<div className="eventos-form-secondary-column">
<div className="eventos-form-label-container" style={{ margin: '0 auto 0 135px', padding: '0', border: 'none' }}>
<ClientesIcon className="eventos-form-icon" style={{ fill: '#2c2c2c' }} />
<label className="eventos-form-label" style={{ margin: '0', padding: '0' }}>Mesa de agasajados</label>
</div>
<div className="eventos-form-invitados-grid">
<div className="eventos-form-invitados-col">
{formData.invitados.slice(0, 7).map((invitado, index) => (
<div key={index} style={{ position: 'relative' }}>
<div
className={`eventos-form-invitado-circle ${invitado ? 'filled' : 'empty'} ${openClientListbox === index ? 'active' : ''}`}
onClick={() => {
setOpenClientListbox(openClientListbox === index ? null : index);
setSearchTerm('');
}}
onMouseEnter={() => handleMouseEnter(index)}
onMouseLeave={handleMouseLeave}
>
{invitado ? (
<>
<span>
{invitado.nombre && invitado.apellido
? `${invitado.nombre.charAt(0).toUpperCase()}${invitado.apellido.charAt(0).toUpperCase()}`
: invitado.nombre
? invitado.nombre.charAt(0).toUpperCase()
: invitado.razonSocial
? invitado.razonSocial.charAt(0).toUpperCase()
: ''}
</span>
<div
className="eventos-form-remove-client"
onClick={(e) => {
e.stopPropagation();
handleRemoveClient(index);
}}
>
&times;
</div>
</>
) : (
<span>+</span>
)}
</div>
{hoveredCircleIndex === index && invitado && (
<div className="custom-tooltip">
{invitado.nombre && invitado.apellido
? `${invitado.nombre} ${invitado.apellido}`
: invitado.nombre
? invitado.nombre
: invitado.razonSocial}
</div>
)}
{}
<div
className={`invitados-listbox-container ${openClientListbox !== index ? 'hidden' : ''} left-col ${index >= 4 && index <= 6 ? 'bottom-listbox' : ''}`}
ref={openClientListbox === index ? dropdownRef : null}
>
<input
type="text"
placeholder="Buscar cliente..."
value={searchTerm}
onChange={(e) => setSearchTerm(e.target.value)}
className="invitados-listbox-search-input"
ref={openClientListbox === index ? searchInputRef : null}
/>
<div className="filter-buttons-container" style={{ display: 'flex', width: '90%', margin: '5px auto 10px', gap: '5px',flexWrap:'wrap' }}>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'clientes' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'clientes' ? 'todos' : 'clientes')}
ref={(el) => (filterButtonsRef.current[0] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Clientes
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'usuarios' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'usuarios' ? '' : 'usuarios')}
ref={(el) => (filterButtonsRef.current[3] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>Empleados
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'proveedores' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'proveedores' ? 'todos' : 'proveedores')}
ref={(el) => (filterButtonsRef.current[1] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Proveedores
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'otros' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'otros' ? 'todos' : 'otros')}
ref={(el) => (filterButtonsRef.current[2] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Otros
</button>
</div>
{filteredContactsByType.length > 0 ? (
<ul className="invitados-listbox-options">
{filteredContactsByType.map((contacto) => (
<li
key={contacto.id}
onClick={() => {
handleSelectClient(contacto, index);
setOpenClientListbox(null);
}}
className="invitados-listbox-option"
>
{contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial}
</li>
))}
</ul>
) : (
<p className="no-results-message">No se encontraron resultados.</p>
)}
</div>
</div>
))}
</div>
<div className="eventos-form-middle-rect"></div>
<div className="eventos-form-invitados-col">
{formData.invitados.slice(7, 14).map((invitado, index) => (
<div key={index + 7} style={{ position: 'relative' }}>
<div
className={`eventos-form-invitado-circle ${invitado ? 'filled' : 'empty'} ${openClientListbox === index + 7 ? 'active' : ''}`}
onClick={() => {
setOpenClientListbox(openClientListbox === index + 7 ? null : index + 7);
setSearchTerm('');
}}
onMouseEnter={() => handleMouseEnter(index + 7)}
onMouseLeave={handleMouseLeave}
>
{invitado ? (
<>
<span>
{invitado.nombre && invitado.apellido
? `${invitado.nombre.charAt(0).toUpperCase()}${invitado.apellido.charAt(0).toUpperCase()}`
: invitado.nombre
? invitado.nombre.charAt(0).toUpperCase()
: invitado.razonSocial
? invitado.razonSocial.charAt(0).toUpperCase()
: ''}
</span>
<div
className="eventos-form-remove-client"
onClick={(e) => {
e.stopPropagation();
handleRemoveClient(index + 7);
}}
>
&times;
</div>
</>
) : (
<span>+</span>
)}
</div>
{hoveredCircleIndex === index + 7 && invitado && (
<div className="custom-tooltip">
{invitado.nombre && invitado.apellido
? `${invitado.nombre} ${invitado.apellido}`
: invitado.nombre
? invitado.nombre
: invitado.razonSocial}
</div>
)}
{}
<div
className={`invitados-listbox-container ${openClientListbox !== index + 7 ? 'hidden' : ''} right-col ${index >= 4 ? 'bottom-listbox' : ''}`}
ref={openClientListbox === index + 7 ? dropdownRef : null}
>
<input
type="text"
placeholder="Buscar cliente..."
value={searchTerm}
onChange={(e) => setSearchTerm(e.target.value)}
className="invitados-listbox-search-input"
ref={openClientListbox === index + 7 ? searchInputRef : null}
/>
<div className="filter-buttons-container" style={{ display: 'flex', width: '90%', margin: '5px auto 10px', gap: '5px',flexWrap:'wrap' }}>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'clientes' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'clientes' ? 'todos' : 'clientes')}
ref={(el) => (filterButtonsRef.current[0] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Clientes
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'usuarios' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'usuarios' ? '' : 'usuarios')}
ref={(el) => (filterButtonsRef.current[3] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>Empleados
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'proveedores' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'proveedores' ? 'todos' : 'proveedores')}
ref={(el) => (filterButtonsRef.current[1] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Proveedores
</button>
<button
type="button"
className={`filter-button ${contactTypeFilter === 'otros' ? 'active' : ''}`}
onClick={() => setContactTypeFilter(contactTypeFilter === 'otros' ? 'todos' : 'otros')}
ref={(el) => (filterButtonsRef.current[2] = el)}
style={{maxWidth:'fit-content', padding:'1px 5px'}}
>
Otros
</button>
</div>
{filteredContactsByType.length > 0 ? (
<ul className="invitados-listbox-options">
{filteredContactsByType.map((contacto) => (
<li
key={contacto.id}
onClick={() => {
handleSelectClient(contacto, index + 7);
setOpenClientListbox(null);
}}
className="invitados-listbox-option"
>
{contacto.nombre && contacto.apellido
? `${contacto.nombre} ${contacto.apellido}`
: contacto.nombre
? contacto.nombre
: contacto.razonSocial}
</li>
))}
</ul>
) : (
<p className="no-results-message">No se encontraron resultados.</p>
)}
</div>
</div>
))}
</div>
</div>
</div>
</div>
<div className="button-container" >
<button
type="submit"
className={`eventos-form-submit-btn ${saveState === 'saved' ? 'success' : ''}`}
disabled={isLoading}
>
<span className="button-text">
{saveState === 'saved' ? 'Guardado' : isEditing ? "Editar evento" : "Crear evento"}
</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button></div>
</form>
</div>
<CalendarModal
isVisible={isCalendarModalVisible}
onClose={handleCloseCalendarModal}
onDatesSelect={handleDatesSelected}
showTimeInput={true}
initialDates={formData.fechas}
/>
</div>
);
};
export default EventosForm;